/**
 * Store Config Resource Client
 * Axios-based API client for store configuration endpoints
 */

import { ApiClient } from './apiClient';

export interface StoreConfig {
    brandLogo?: string;
    favicon?: string;
    badges?: {
        url: string;
        title: string;
    }[];
    colors?: {
        primary?: string;
        [key: string]: any;
    };
    sections?: {
        id: string;
        title: string;
        iconUrl?: string;
        titleTrans?: {
            [lang: string]: string;
        };
        descriptionTrans?: {
            [lang: string]: string;
        };
    }[];
    checkoutType?: string;
    requirePhone?: boolean;
    requireTerms?: boolean;
    scarcityTimer?: {
        enabled: boolean;
        messageTrans?: {
            [lang: string]: string;
        };
        duration?: number;
        [key: string]: any;
    };
    showPoweredBy?: boolean;
    precheckMarketing?: boolean;
    privacyPolicyLink?: string;
    requireAddressNumber?: boolean;
    generalConditionsLink?: string;
    computed?: {
        availableShippingCountries?: string[];
        threedsEnabled?: boolean;
        [key: string]: any;
    };

    [key: string]: any;
}

export interface GetStoreConfigOptions {
    storeId: string;
}

export class StoreConfigResource {
    constructor(private apiClient: ApiClient) { }

    /**
     * Get store configuration by store ID
     */
    async getStoreConfig(storeId: string): Promise<StoreConfig> {
        const response = await this.apiClient.get<StoreConfig>(
            `/api/v1/checkout/config?storeId=${storeId}`
        );

        return response;
    }
}

